export default __webpack_public_path__ + "static/media/mescladora.fea202ac.png";